import FormStreamingQuery from "@/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery";

const DEFAULT_WINDOWS_SIZE = 32;

export default class StreamingQuery{
    constructor() {
        this.case = '';
        this.filteringMode = false;
        this.dataClass = null;
        this.order = [];
        this.windowSize = DEFAULT_WINDOWS_SIZE;
        this.locateId = null;
        this.viewLocateId = null;
        this.uuid = null;
        this.form = null;
        this.offset = 0;
        this.complexTextQuery = null;
        this.colFilterSpec = null;
        this.textQuery = null;
        this.activeColumns = null;
        this.clusteringId = null;
        this.onlyIds = [];
        this.excludedIds = [];
        this.isDetail = false;
        this.isView = false;
        this.detailsMasterClassLong = null;
        this.detailsMasterId = null;
        this.detailsJoiningField = null;
        this.refreshComparator = null;
        this.dynamicFilterSpec = null;
        this.dynamicForm = null;
        this.forceViewReset = false;
    }

    viewSignature(){
        return JSON.stringify(this.textQuery) + "::" + JSON.stringify(this.locateId) +
        "::" + JSON.stringify(this.clusteringId) + "::" +
            "::" + JSON.stringify(this.colFilterSpec) + "::" + JSON.stringify(this.dynamicFilterSpec);
    }
    /**
     * @returns {FormStreamingQuery}
     */
    toFormStreamingQuery(){
        let numQ = null;
        this.textQuery = this.textQuery?.trim();
        if (this.textQuery && this.textQuery.match(/^[\d,.]+$/)) {
            if(!isNaN(parseFloat(this.textQuery))){
                numQ = new BigDecimal(parseFloat(this.textQuery));
            }
        }
        return new FormStreamingQuery().
            withQueryCase(this.case).withFilteringMode(this.filteringMode).
            withOrder(this.order).
            withDataClass(this.dataClass).
            withQueryCase(this.case).
            withWindowSize(this.windowSize).
            withOffset(this.offset).
            withUuid(this.uuid).
            withOrder(this.order).
            withTextQuery(this.textQuery).
            withNumericQuery(numQ).
            withViewLocateId(this.viewLocateId).
            withActiveColumns(this.activeColumns).
            withClusteringId(this.clusteringId).
            withExcludedIds(this.excludedIds).
            withOnlyIds(this.onlyIds).
            withIsDetail(this.isDetail).
            withLocateId(this.locateId).
            withDetailsMasterClassLong(this.detailsMasterClassLong).
            withDetailsMasterId(this.detailsMasterId).
            withDetailsJoiningField(this.detailsJoiningField).
            withMulticolumnSearch(this.complexTextQuery).
            withRawColFilterSpec(JSON.stringify(this.colFilterSpec)).
            withDynamicFilterSpec(JSON.stringify(this.dynamicFilterSpec));

    }
}

StreamingQuery.DEFAULT_WINDOWS_SIZE = DEFAULT_WINDOWS_SIZE;
